export default {
  pageTitle: '製品',
  metaDescription: 'TEFの製作製品をご覧ください：圧力容器、熱交換器、配管、塔槽、マッフル、ラジアントチューブなど、特殊材料を用いた産業機器。',
  fabricationOf: '製作',
  categories: {
    vessel: 'ベッセル',
    heatExchanger: '熱交換器',
    piping: '配管',
    tower: '塔槽',
    radiantTube: 'ラジアントチューブ',
    muffle: 'マッフル',
    otherEquipment: 'その他の設備',
  },
  onSiteServices: {
    heading: '現地サービス',
    items: {
      weldingOverlay: '溶接オーバーレイ',
      patching: 'パッチング補修',
      piping: '配管工事',
      reShell: 'シェル更新（リシェル）',
      reTubing: 'リチューブ',
      shutdownMaintenance: 'シャットダウンメンテナンス',
    },
  },
};
